import { html } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element";
import "@stofloos/components/atoms/loaders/loader-checkmark";
import { cloudUploadIcon } from "@stofloos/components/atoms/icons/sw-icons";

import { style } from "./style";
import { store } from "@stofloos/stores/store";
import { connect } from "pwa-helpers";

import { readPrivateImage, uploadImage } from "@stofloos/actions/file";
import { initRequest } from "@stofloos/actions/requests";

import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

class InputImageDropzone extends connect(store)(StofwareElement) {
	static get styles() {
		return [LayoutFlex, style];
	}

	render() {
		return html`
			<div class="imageDropzone layout vertical">
				<input
					multiple
					id="fileInput"
					@drop="${e => {
						this.fileDropped(e);
					}}"
					@change="${e => {
						this.fileDropped(e);
					}}"
					type="file"
				/>

				${!this.fileStatus
					? html`
							${cloudUploadIcon}
							<span class="t-center">Selecteer een afbeelding</span>
					  `
					: html``}
				${this.fileStatus === "load-complete"
					? html`
							<loader-checkmark status="load-complete"></loader-checkmark>
							<span class="t-center">Afbeelding geselecteerd</span>
					  `
					: ""}
				${this.fileStatus === "loading"
					? html`
							<loader-checkmark status="loading"></loader-checkmark>
					  `
					: ""}
			</div>

			<div class="layout horizontal">
				${this.isPrivate && this.base64Images && this.base64Images.length > 0
					? html`
							${this.base64Images.map(image => {
								return html`
									<div class="image flex">
										<img src="data:image/png;base64, ${image}" />
									</div>
								`;
							})}
					  `
					: html`
							${!this.single && this.images && this.images.length > 0
								? html`
										${this.images.map(image => {
											return html`
												<div class="image flex">
													<img src="${image}" />
												</div>
											`;
										})}
								  `
								: html``}
							${this.single && this.images
								? html`
										<div class="image flex">
											<img src="${this.images}" />
										</div>
								  `
								: html``}
					  `}
			</div>

			<div class="layout horizontal">
				${!this.single && this.images && this.images.length > 0
					? html`
							${this.images.map(image => {
								return html`
									<input hidden name="${this.requestId}[]" value="${image}" type="text" />
								`;
							})}
					  `
					: html``}
				${this.single && this.images
					? html`
							<input hidden name="${this.requestId}" value="${this.images}" type="text" />
					  `
					: html``}
			</div>
		`;
	}

	constructor() {
		super();
		this.isPrivate = false;
		this.basePath = "";
	}

	firstUpdated() {
		if (this.isPrivate && this.images && this.images.length > 0) {
			this.getPrivateImages(this.images);
		}
	}

	getPrivateImages(values) {
		store.dispatch(initRequest(this.requestId + "base64", "image"));
		let params = { image_paths: values };
		store.dispatch(readPrivateImage(this.requestId + "base64", params));
	}

	static get properties() {
		return {
			fileName: String,
			fileStatus: String,
			requestId: { type: String },
			basePath: { type: String },
			isPrivate: { type: Boolean },
			single: { type: Boolean },
			images: { type: Array },
			base64Images: { type: Array }
		};
	}

	stateChanged(state) {
		//Get private images from store by request
		if (this.isPrivate && state.file[this.requestId] && state.file[this.requestId] !== this.images) {
			this.images = state.file[this.requestId];
			if (this.isPrivate) {
				this.getPrivateImages(this.images);
			}
		} else if (state.file[this.requestId] && state.file[this.requestId] !== this.images) {
			this.images = state.file[this.requestId];
		}

		if (
			this.isPrivate &&
			state.file[this.requestId + "base64"] &&
			state.file[this.requestId + "base64"] !== this.base64Images
		) {
			this.base64Images = state.file[this.requestId + "base64"];
		}
	}

	fileDropped(e) {
		e.preventDefault();
		if (e.dataTransfer) {
			e.target.files = e.dataTransfer.files;
		}
		this.fileStatus = "loading";
		let imageFile = this.shadowRoot.getElementById("fileInput").files;
		if (imageFile) {
			store.dispatch(uploadImage(this.requestId, imageFile, this.basePath, this.isPrivate));
			this.fileStatus = "load-complete";
		}
	}
}

customElements.define("input-image-dropzone", InputImageDropzone);
